import React, { useContext, useState } from "react";
import Heading from "./Heading";
import { MdCheckCircle, MdError } from "react-icons/md";
import { ImSpinner2 } from "react-icons/im";
import axios from "axios";
import SideBar from "./SideBar";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import AnimationContext from "../contexts/animation/AnimationContext";

const Contact = () => {
  const { ref, inView } = useInView({ threshold: 0.2 });
  const { setAnimation } = useContext(AnimationContext);
  const inViewVariants = setAnimation(inView);

  const [serverState, setServerState] = useState({
    submitting: false,
    status: null,
  });
  const handleServerResponse = (ok, msg) => {
    setServerState({
      submitting: false,
      status: { ok, msg },
    });
    if (ok) {
      setFormData({
        name: "",
        phone: "",
        email: "",
        subject: "",
        comment: "",
      });
    }
  };
  const [indicator, setIndicator] = useState({
    name: false,
    phone: false,
    email: false,
    subject: false,
    comment: false,
  });
  const [valid, setValid] = useState({
    name: false,
    phone: false,
    email: false,
    subject: false,
    comment: false,
  });
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    subject: "",
    comment: "",
  });
  const handleChange = (e) => {
    validateData(e.target.name);
    setFormData(() => ({
      ...formData,
      [e.target.name]: e.target.value,
    }));
  };
  const validateData = (field) => {
    switch (field) {
      case "name":
        var regex = /[A-Z]{3,}/gi;
        makeItValid(regex.test(formData[field]), field);
        break;
      case "email":
        var regex =
          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        makeItValid(regex.test(formData.email), field);
        break;
      case "phone":
        var regex = /[0-9]{10,}/;
        makeItValid(regex.test(formData.phone), field);
        break;
      case "subject":
        var regex = /./;
        makeItValid(regex.test(formData.subject), field);
        break;
      default:
        break;
    }
  };
  const makeItValid = (result, field) => {
    valid[field] = result;
    setValid(() => valid);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!valid.name && !valid.email && !valid.phone && !valid.subject) return;
    setServerState({ submitting: true });
    axios({
      method: "POST",
      url: "https://formspree.io/f/xpzbbkjq",
      data: formData,
    })
      .then((r) => {
        handleServerResponse(true, "Thanks!");
      })
      .catch((r) => {
        handleServerResponse(false, r.response.data.error);
      });
    setTimeout(() => {
      setServerState({ submitting: false, status: null });
    }, 5000);
  };

  return (
    <section ref={ref} className="bg-prColor" id="contact">
      <div className="container pt-[40px] sm:pt-[60px] md:pt-[90px] pb-6 sm:pb-12 ">
        <div className="max-w-3xl lg:max-w-none mx-auto mb-8 sm:mb-16">
          <Heading title={"Contact Me"} subTitle={"Get in Touch"} />
        </div>
        <motion.div
          variants={inViewVariants}
          initial="hidden"
          animate="visible"
          className="max-w-3xl lg:max-w-none mx-auto"
        >
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3369.9145137465825!2d71.40074641731209!3d32.367838729489364!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3926e2c04ac6c5df%3A0x6a03503bd96824b6!2sSulmaniya%20Masjid!5e0!3m2!1sen!2s!4v1650264440631!5m2!1sen!2s"
            className="w-full h-[280px] xs:h-[350px] md:h-[450px] lg:h-[500px]"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Location"
          ></iframe>
          <div className="flex gap-12 flex-col-reverse lg:flex-row">
            <div className="w-full lg:w-fit flex flex-col gap-16 relative lg:-top-[18rem] lg:-mb-[18rem] ">
              <SideBar
                infos={[
                  { title: "Phone:", details: +923425301620 },
                  { title: "Email:", details: "m.sherazsaeed17@gmail.com" },
                  { title: "Address:", details: "Mianwali, Punjab, Pakistan" },
                ]}
                subTitle="Follow Me"
                links={[
                  {
                    url: "https://www.linkedin.com/in/sherridev/",
                    icon: "linkedIn",
                  },
                  {
                    url: "https://web.facebook.com/SherazSaeed17/",
                    icon: "fb",
                  },
                ]}
                bgPr={false}
              />
            </div>
            <div className="mt-16 font-['Merriweather']">
              <h1 className="text-[1.4rem] font-semibold sm:font-normal sm:text-3xl text-light mb-8 sm:mb-12">
                Looking For Help? Contact me!
              </h1>
              <form
                action="https://formspree.io/f/xpzbbkjq"
                onSubmit={handleSubmit}
                className="text-light text-lg font-['Poppins'] "
              >
                <div className="flex lg:gap-6 flex-col lg:flex-row">
                  <div>
                    <div className=" relative">
                      <div
                        className={`${indicator.name && "indicator"} ${
                          valid.name ? "is-valid" : "is-invalid"
                        } top-1/2 -translate-y-1 right-3`}
                      ></div>
                      <input
                        type="text"
                        className="field"
                        name="name"
                        placeholder="Name: (At least 3 alphabets)"
                        required
                        value={formData.name}
                        onChange={handleChange}
                        onFocus={() =>
                          setIndicator({ ...indicator, name: true })
                        }
                        onBlur={() =>
                          setIndicator({ ...indicator, name: false })
                        }
                      />
                    </div>
                    <div className="relative">
                      <div
                        className={`${indicator.email && "indicator"} ${
                          valid.email ? "is-valid" : "is-invalid"
                        } top-1/2 -translate-y-1 right-3`}
                      ></div>
                      <input
                        type="email"
                        className="field"
                        name="email"
                        placeholder="Email "
                        required
                        value={formData.email}
                        onChange={handleChange}
                        onFocus={() =>
                          setIndicator({ ...indicator, email: true })
                        }
                        onBlur={() =>
                          setIndicator({ ...indicator, email: false })
                        }
                      />
                    </div>
                  </div>
                  <div>
                    <div className="relative">
                      <div
                        className={`${indicator.phone && "indicator"} ${
                          valid.phone ? "is-valid" : "is-invalid"
                        } top-1/2 -translate-y-1 right-3`}
                      ></div>
                      <input
                        type="tel"
                        className="field"
                        name="phone"
                        placeholder="Phone: optional - (10 or more digit Number)"
                        value={formData.phone}
                        onChange={handleChange}
                        onFocus={() =>
                          setIndicator({ ...indicator, phone: true })
                        }
                        onBlur={() =>
                          setIndicator({ ...indicator, phone: false })
                        }
                      />
                    </div>
                    <div className="relative">
                      <div
                        className={`${indicator.subject && "indicator"} ${
                          valid.subject ? "is-valid" : "is-invalid"
                        } top-1/2 -translate-y-1 right-3`}
                      ></div>
                      <input
                        type="text"
                        className="field"
                        name="subject"
                        placeholder="Subject"
                        required
                        value={formData.subject}
                        onChange={handleChange}
                        onFocus={() =>
                          setIndicator({ ...indicator, subject: true })
                        }
                        onBlur={() =>
                          setIndicator({ ...indicator, subject: false })
                        }
                      />
                    </div>
                  </div>
                </div>
                <textarea
                  name="comment"
                  id="comment"
                  className="h-[12rem] field"
                  placeholder="Comment"
                  value={formData.comment}
                  onChange={handleChange}
                ></textarea>
                <button
                  type="submit"
                  className="btn-primary disabled:bg-dark/20 mt-8"
                  disabled={serverState.submitting}
                >
                  {!serverState.status && !serverState.submitting ? (
                    <>Submit Message</>
                  ) : serverState.submitting ? (
                    <>
                      Submitting
                      <ImSpinner2 className="text-2xl text-dark animate-spin" />
                    </>
                  ) : !serverState.status.ok ? (
                    <>
                      <MdError className="text-red-500 text-2xl" />
                      <span className="text-light">
                        {serverState.status.msg}
                      </span>
                    </>
                  ) : serverState.status.ok ? (
                    <>
                      <MdCheckCircle className="text-green-500 text-2xl" />
                      <span className="text-light">
                        {serverState.status.msg}
                      </span>
                    </>
                  ) : (
                    ""
                  )}
                </button>
              </form>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
export default Contact;
